<template>
    <CLoader :pConfigLoad="ConfigLoad">
        {{ DesbloquearBoton }}
        <template slot="BodyFormLoad">
            <div class="container-fluid">
                <form id="FormEncuesta" role="form" method="post" autocomplete="off" onSubmit="return false">
                    <div class="form-group row">
                        <div class="col-sm-12 col-lg-4">
                            <label class="form-label" for="Anio">Año de Encuesta</label>
                            <select :disabled="DesactivarAnio" @change="SeleccionAnio" v-model="objConfigEncuesta.Anio" class="form-control-search form-select" id="Anio">
								<option value="">Seleccione una opción</option>
								<option v-for="(item, index) in Anios" :key="index" :value="item">{{item}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.Anio" :Mensaje="'*'+errorvalidacion.Anio[0]"/>
                        </div>
                        <div class="col-sm-12 col-lg-4">
                            <label class="form-label" for="TipoEncuesta">Tipo de Encuesta</label>
                            <select :disabled="DesactivarTipo" @change="SeleccionTipo" v-model="objConfigEncuesta.TipoEncuesta" class="form-control-search form-select" id="TipoEncuesta">
								<option value="">Seleccione una opción</option>
								<option v-for="(item, index) in TiposEncuesta" :key="index" :value="item">{{item}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.TipoEncuesta" :Mensaje="'*'+errorvalidacion.TipoEncuesta[0]"/>
                        </div>
                        <div class="col-sm-12 col-lg-4">
                            <label class="form-label" for="Idioma">Idioma</label>
                            <select :disabled="DesactivarIdioma" @change="ListarOpcionesDefaultEncuesta('todos')" v-model="objConfigEncuesta.Idioma" class="form-control-search form-select" id="Idioma">
								<option value="">Seleccione una opción</option>
								<option v-for="(item, index) in Idiomas" :key="index" :value="item.Valor">{{item.Label}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.TipoEncuesta" :Mensaje="'*'+errorvalidacion.TipoEncuesta[0]"/>
                        </div>
                    </div>

                    <div v-show="MostrarPestanias" class="form-group row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                            <nav>
                                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                                    <button @click="CambiarTipoOpcion('Default')" type="button" class="nav-link active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true">
                                        Opciones Por Defecto
                                    </button>

                                    <button @click="CambiarTipoOpcion('Encuesta')" type="button" class="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" role="tab" aria-controls="nav-profile" aria-selected="false">
                                        Opciones Encuesta
                                    </button>
                                </div>
                            </nav>

                            <div class="tab-content" id="nav-tabContent">
                                <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                                    <div class="col-lg-12">
                                        <div class="row">
                                            <div class="col-lg-5">
                                                <label for="">Opciones</label>
                                            </div>
                                            <div class="col-lg-2">
                                                <label for="">Valoración</label>
                                            </div>
                                            <div class="col-lg-2">
                                                <label for="">Eliminar</label>
                                            </div>
                                            <div class="col-lg-3">
                                                <div class="btn-group" role="group" aria-label="basic">
                                                    <button v-show="!BloquearEdicion" @click="AgregarOpcion" class="btn btn-sm btn-primary" type="button"><i class="fa fa-plus"></i></button>
                                                    <button v-show="!BloquearEdicion" @click="Reiniciar('default')" class="btn btn-sm btn-primary" type="button"><i class="fa fa-refresh"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-for="(item,index) in ListaOpcionesDefault" :key="index" class="row mb-1">
                                            <div class="col-xs-12 col-sm-12 col-md-5">
                                                <input :disabled="item.IdConfigEncuestaOpcionBase!=0" type="text" class="form-control" v-model="item.Nombre">
                                            </div>
                                            <div class="col-xs-12 col-sm-12 col-md-2">
                                                <input :disabled="BloquearEdicion" @input="$onlyNums($event,item,'Valoracion');" type="text" class="form-control" v-model="item.Valoracion">
                                            </div>
                                            <div class="col-xs-12 col-sm-12 col-md-2">
                                                <button v-show="!BloquearEdicion" @click="EliminarOpcion(index,'Default')" type="button" class="btn btn-danger"><i class="fa fa-trash"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade show" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                                    <div class="col-lg-12">
                                        <div class="row">
                                            <div class="col-lg-7">
                                                <label for="">Opciones</label>
                                            </div>
                                            <div class="col-lg-2">
                                                <label for="">Eliminar</label>
                                            </div>
                                            <div class="col-lg-3">
                                                <div class="btn-group" role="group" aria-label="basic">
                                                    <button v-show="!BloquearEdicion" @click="AgregarOpcion()" class="btn btn-sm btn-primary" type="button"><i class="fa fa-plus"></i></button>
                                                    <button v-show="!BloquearEdicion" @click="Reiniciar('encuesta')" class="btn btn-sm btn-primary" type="button"><i class="fa fa-refresh"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-for="(item,index) in ListaOpcionesEncuesta" :key="index" class="row mb-1">
                                            <div class="col-xs-12 col-sm-12 col-md-7">
                                                <input :disabled="item.IdConfigEncuestaOpcionBase!=0" type="text" class="form-control" v-model="item.Nombre">
                                            </div>
                                            <!-- <div class="col-xs-12 col-sm-12 col-md-2">
                                                <input @input="$onlyNums($event,item,'Valoracion');" type="text" class="form-control" v-model="item.Valoracion">
                                            </div> -->
                                            <div class="col-xs-12 col-sm-12 col-md-2">
                                                <button v-show="!BloquearEdicion" @click="EliminarOpcion(index,'Encuesta')" type="button" class="btn btn-danger"><i class="fa fa-trash"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </template>
    </CLoader>
</template>

<script>
export default {
    name: 'FormEncuesta',
    props: ['poBtnSave','pListaEncuesta'],
    components:{
    },
    data() {
        return {
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objConfigEncuesta: {
				IdConfigEncuesta: 0,
				TipoEncuesta: '',
				Anio: '',
				Idioma:'',
				Estatus:'',
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
            Anios:[],
            TiposEncuesta:[],
            Idiomas:[],
            ListaOpcionesDefault:[],
            ListaOpcionesEncuesta:[],
            TipoOpcion:'Default',
            DesactivarAnio:false,
            DesactivarTipo:false,
            DesactivarIdioma:false,
            BloquearEdicion:false
        }
    },
    methods: {
        async Guardar(){
            this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;
            this.poBtnSave.ShowSpinner=true;

            let BndError=false;
            let Mensaje='';
            if (this.ListaOpcionesDefault.length==0) {
                BndError=true;
                Mensaje="Debe Haber al Menos 1 Opción en las Opciones por Defecto"
            }
            else if(this.ListaOpcionesEncuesta.length==0){
                BndError=true;
                Mensaje="Debe Haber al Menos 1 Opción en las Opciones de la Encuesta"
            }
            this.ListaOpcionesDefault.every((element)=>{
                if (element.Nombre=='') {
                    Mensaje="El Nombre de las Opciones por Defecto No Puede Estar Vacío";
                    BndError=true;
                    return false;
                }
                return true
            })
            this.ListaOpcionesEncuesta.every((element)=>{
                if (element.Nombre=='') {
                    Mensaje="El Nombre de las Opciones de Encuesta No Puede Estar Vacío";
                    BndError=true;
                    return false;
                }
                return true
            })

            if (BndError) {
                this.$toast.warning(Mensaje);
                this.poBtnSave.DisableBtn=false;
                return false;
            }

            let formData=new FormData();
            formData.set('IdConfigEncuesta',this.objConfigEncuesta.IdConfigEncuesta);
            formData.set('TipoEncuesta',this.objConfigEncuesta.TipoEncuesta);
            formData.set('Anio',this.objConfigEncuesta.Anio);
            formData.set('Idioma',this.objConfigEncuesta.Idioma);
            formData.set('Estatus',this.objConfigEncuesta.Estatus);
            formData.set('OpcionesDefault',JSON.stringify(this.ListaOpcionesDefault));
            formData.set('OpcionesEncuesta',JSON.stringify(this.ListaOpcionesEncuesta));
            await this.$http.post("/configEncuestas",formData
            ).then((res)=>{
                this.EjecutaConExito(res);
            }).catch((err)=>{
                this.EjecutaConError(err);
            })
        },
        EjecutaConExito(res){
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err){
            this.poBtnSave.DisableBtn = false;
            this.poBtnSave.ShowSpinner=false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Recuperar(){
            this.SeleccionAnio();
            this.SeleccionTipo();
            this.$http.get("configEncuestas/"+this.objConfigEncuesta.IdConfigEncuesta
            ).then((res)=>{
                this.objConfigEncuesta=res.data.data.ConfigEncuesta;
                this.ListaOpcionesDefault=res.data.data.OpcionesDefault;
                this.ListaOpcionesEncuesta=res.data.data.OpcionesEncuesta;
                this.BloquearEdicion=res.data.data.BloquearEdicion;
                this.DesactivarAnio=true;
                this.DesactivarTipo=true;
                this.DesactivarIdioma=true;
                res.data.anios.forEach(element => {
                    this.Anios.push(element);
                });
            }).finally(()=>{
                if (this.BloquearEdicion) {
                    this.poBtnSave.DisableBtn=true;
                    this.poBtnSave.ShowSpinner=false;
                }
                else{
                    this.poBtnSave.DisableBtn=false;
                }
                this.ConfigLoad.ShowLoader=false;
            })
        },
        Limpiar(){
            this.Anios=[];
            this.BloquearEdicion=false;
            this.DesactivarAnio=false,
            this.DesactivarTipo=false;
            this.DesactivarIdioma=false;
        },
        IniciarSeleccionEncuesta(){
            let AnioActual=new Date().getFullYear();
            let AnioEntrante=new Date().getFullYear()+1;
            this.Anios.push(AnioActual);
            this.Anios.push(AnioEntrante);
        },
        SeleccionAnio(){
            // this.poBtnSave.DisableBtn=true;
            // this.poBtnSave.ShowSpinner=false;
            this.objConfigEncuesta.TipoEncuesta="";
            this.TiposEncuesta=[];
            this.Idiomas=[];
            this.objConfigEncuesta.Idioma="";
            let bndCoordinadorAnio=this.pListaEncuesta.some((element)=>{
                let bnd;
                bnd=element.Anio==this.objConfigEncuesta.Anio && element.TipoEncuesta=="COORDINADOR";
                return bnd;
            });
            if (!bndCoordinadorAnio) {
                this.TiposEncuesta.push('COORDINADOR');
            }
            let BndParejasAnioEsp=this.pListaEncuesta.some((element)=>{
                let bnd;
                bnd=element.Anio==this.objConfigEncuesta.Anio && element.TipoEncuesta=="PAREJAS" && element.Idioma=="ESP"
                return bnd;
            });
            let BndParejasAnioEng=this.pListaEncuesta.some((element)=>{
                let bnd;
                bnd=element.Anio==this.objConfigEncuesta.Anio && element.TipoEncuesta=="PAREJAS" && element.Idioma=="ENG"
                return bnd;
            });
            if (!BndParejasAnioEsp || !BndParejasAnioEng) {
                this.TiposEncuesta.push('PAREJAS');
            }
            if (this.TiposEncuesta.length==0) {
                this.$toast.warning("Ya se Agregaron Todas las Encuestas de Este Año");
            }
        },
        SeleccionTipo(){
            this.Idiomas=[];
            this.objConfigEncuesta.Idioma="";
            if (this.objConfigEncuesta.TipoEncuesta=="COORDINADOR") {
                this.Idiomas.push({Valor:"ESP",Label:"ESPAÑOL"});
            }
            else{
                let BndParejasAnioEsp=this.pListaEncuesta.some((element)=>{
                    let bnd;
                    bnd=element.Anio==this.objConfigEncuesta.Anio && element.TipoEncuesta=="PAREJAS" && element.Idioma=="ESP"
                    return bnd;
                });
                if (!BndParejasAnioEsp) {
                    this.Idiomas.push({Valor:"ESP",Label:"ESPAÑOL"});
                }

                let BndParejasAnioEng=this.pListaEncuesta.some((element)=>{
                    let bnd;
                    bnd=element.Anio==this.objConfigEncuesta.Anio && element.TipoEncuesta=="PAREJAS" && element.Idioma=="ENG"
                    return bnd;
                });
                if (!BndParejasAnioEng) {
                    this.Idiomas.push({Valor:"ENG",Label:"INGLÉS"});
                }
            }
        },
        CambiarTipoOpcion(Opcion){
            this.TipoOpcion=Opcion;
        },
        ListarOpcionesDefaultEncuesta(opcion){
            this.$http.get("configEncuestaOpcionesBaseRecovery",{
                params:{
                    Anio:this.objConfigEncuesta.Anio,
                    Categoria:this.objConfigEncuesta.TipoEncuesta,
                    Idioma:this.objConfigEncuesta.Idioma
                }
            }).then((res)=>{
                switch (opcion) {
                    case 'todos':
                        this.poBtnSave.DisableBtn=false;
                        this.ListaOpcionesDefault=res.data.data.OpcionesDefault;
                        this.ListaOpcionesEncuesta=res.data.data.OpcionesEncuesta;
                        break;
                    case 'default':
                        this.ListaOpcionesDefault=res.data.data.OpcionesDefault;
                        break;
                    case 'encuesta':
                        this.ListaOpcionesEncuesta=res.data.data.OpcionesEncuesta;
                        break;
                }
            })
        },
        AgregarOpcion(){
            let obj={
                IdConfigEncuestaOpcionBase:0,
                Nombre:'',
                Anio:this.objConfigEncuesta.Anio,
                Categoria:this.objConfigEncuesta.TipoEncuesta,
                Idioma:this.objConfigEncuesta.Idioma,
                Tipo:'',
                IdEmpresa:0,
                IdSucursal:0
            }
            switch (this.TipoOpcion) {
                case 'Default':
                    obj.Tipo="opcion";
                    this.ListaOpcionesDefault.push(obj);
                    break;
                case 'Encuesta':
                    obj.Tipo="encuesta";
                    this.ListaOpcionesEncuesta.push(obj);
                    break;
                default:
                    break;
            }
        },
        EliminarOpcion(index,NombreArray){
            switch (NombreArray) {
                case 'Default':
                    this.ListaOpcionesDefault.splice(index,1);
                    break;
                case 'Encuesta':
                    this.ListaOpcionesEncuesta.splice(index,1);
                    break;
            }
        },
        Reiniciar(opcion){
            this.ListarOpcionesDefaultEncuesta(opcion);
        }
    },
    created() {
        this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
            if (Id!='') 
            {
                this.objConfigEncuesta.IdConfigEncuesta = Id;
                this.poBtnSave.ShowSpinner=true;
                this.Recuperar();
            }
            else
            {
                this.poBtnSave.DisableBtn=true;
                this.poBtnSave.ShowSpinner=false;
                this.ConfigLoad.ShowLoader = false;
            }
            this.IniciarSeleccionEncuesta();
        });
    },
    computed:{
        MostrarPestanias:function(){
            if (this.objConfigEncuesta.Idioma=='') {
                return false
            }
            else{
                return true
            }
        },
        DesbloquearBoton:function(){
            if (this.objConfigEncuesta.Idioma=="") {
                this.poBtnSave.DisableBtn=true;
            }
            else{
                this.poBtnSave.DisableBtn=false;
            }
        }
    }
}
</script>

<style>

</style>